export const notificationType ={
    ERROR   :   'error',
    SUCCESS :   'success',
    WARNING :   'warning',
    INFO    :   'info'
}